import { render, staticRenderFns } from "./MonthlyActivityRank.vue?vue&type=template&id=67b37926&scoped=true&"
import script from "./MonthlyActivityRank.vue?vue&type=script&lang=ts&"
export * from "./MonthlyActivityRank.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b37926",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
